/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { collectionTypeSchema } from '../collection-type';
import { collectionNarrowV3Schema } from '../getPublicCollectionBySlugV3/get-public-collection-by-slug-v3-response';

export const collectionParentV4Schema = z.object({
  slug: z.string(),
  title: z.string(),
});

export type ICollectionParentV4 = z.infer<typeof collectionParentV4Schema>;

export const collectionChildV4Schema = z.object({
  id: z.number(),
  slug: z.string(),
  title: z.string(),
  posterUrl: z.string().nullable(),
  publishedChallengesCount: z.number(),
  titleInPoster: z.number().default(0),
});

export type ICollectionChildV4 = z.infer<typeof collectionChildV4Schema>;

export const collectionNarrowV4Schema = collectionNarrowV3Schema.extend({
  parent: collectionParentV4Schema.nullable(),
  children: z.array(collectionChildV4Schema),
  type: collectionTypeSchema.nullable().optional(),
  year: z.number().nullable().optional(),
  genre: z.string().nullable().optional(),
  tagline: z.string().nullable().optional(),
  runtimeMinutes: z.number().nullable().optional(),
  originalLanguage: z.string().nullable().optional(),
  spokenLanguages: z.array(z.string()).optional().default([]),
  productionCountries: z.array(z.string()).optional().default([]),
  boxOffice: z.number().nullable().optional(),
  contentRating: z.string().nullable().optional(),
  releaseDate: z.string().nullable().optional(),
  imdbId: z.string().nullable().optional(),
});

export type ICollectionV4 = z.infer<typeof collectionNarrowV4Schema>;

export const getPublicCollectionBySlugV4ResponseSchema = createApiResponseSchema(
  collectionNarrowV4Schema,
) as z.ZodSchema<IAPI<ICollectionV4>>;

export type IGetPublicCollectionBySlugV4Response = IAPI<ICollectionV4>;
